<template>
  <div>
    <button
      :aria-label="previousText"
      class="rfp-ratings-carousel-prev-next-button rfp-ratings-carousel-previous"
      :style="`padding: ${clickTargetSize}px; margin-right: -${clickTargetSize}px;`"
      :class="{ 'rfp-ratings-carousel-navigation--disabled': !canAdvanceBackward }"
      :disabled="!canAdvanceBackward"
      @click="$emit('navigate-prev')"
    >
      &larr;
    </button>
    <button
      :aria-label="nextText"
      class="rfp-ratings-carousel-prev-next-button rfp-ratings-carousel-next"
      :style="`padding: ${clickTargetSize}px; margin-left: -${clickTargetSize}px;`"
      :class="{ 'rfp-ratings-carousel-navigation--disabled': !canAdvanceForward }"
      :disabled="!canAdvanceForward"
      @click="$emit('navigate-next')"
    >
      &rarr;
    </button>
  </div>
</template>

<script>
export default {
  name: 'rfp-ratings-navigation',
  inject: ['previousText', 'nextText'],
  props: {
    clickTargetSize: {
      type: Number,
      default: 8,
    },
    canAdvanceBackward: {
      type: Boolean,
      default: false,
    },
    canAdvanceForward: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
